import React, { useMemo } from 'react';
import { LDProvider } from 'launchdarkly-react-client-sdk';
import { useAuth } from '../../contexts/AuthContext';

interface LaunchDarklyWrapperProps {
  children: React.ReactNode;
}

const LaunchDarklyWrapper: React.FC<LaunchDarklyWrapperProps> = ({ children }) => {
  const { user } = useAuth();

  const ldProviderConfig = useMemo(() => ({
    clientSideID: import.meta.env.VITE_LAUNCHDARKLY_CLIENT_SIDE_ID || '',
    user: user ? {
      key: user.email,
      email: user.email,
      firstName: user.first_name,
      lastName: user.last_name,
      custom: {
        username: user.username,
        id: user.id
      }
    } : {
      key: 'anonymous',
      anonymous: true,
    },
  }), [user]);

  return (
    <LDProvider {...ldProviderConfig}>
      {children}
    </LDProvider>
  );
};

export default LaunchDarklyWrapper;
